import { render, staticRenderFns } from "./resultLogic.vue?vue&type=template&id=0964c745&"
import script from "./resultLogic.vue?vue&type=script&lang=js&"
export * from "./resultLogic.vue?vue&type=script&lang=js&"
import style0 from "./resultLogic.vue?vue&type=style&index=0&id=0964c745&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports